import { API } from '../Api';

// "Vòng quay" của streamer: các ô là NHIỆM VỤ streamer sẽ làm (không phải phần thưởng
// quy đổi được). Người xem trả Ca để quay, tiền đi qua đúng luồng donate.

export interface SpinWheelItemView {
  label: string;
  /** null khi streamer tắt hiện tỉ lệ (BE không trả ra). */
  weight: number | null;
  percent: number | null;
}

export interface SpinWheel {
  exists: boolean;
  isActive: boolean;
  spinPrice: number;
  showOdds: boolean;
  items: SpinWheelItemView[];
}

export interface SaveSpinWheelBody {
  isActive: boolean;
  spinPrice: number;
  showOdds: boolean;
  items: { label: string; weight: number }[];
}

export interface SpinResult {
  itemLabel: string;
  pricePaid: number;
  balanceAfter: number;
}

export const getMySpinWheel = () =>
  API.get<SpinWheel>('/v1/payment-service/spin-wheel/me').then((r) => r.data);

export const saveSpinWheel = (body: SaveSpinWheelBody) =>
  API.post<SpinWheel>('/v1/payment-service/spin-wheel', body).then((r) => r.data);

// expectedPrice = giá đang hiện trên nút. Streamer đổi giá giữa chừng thì BE từ chối, không trừ Ca.
export const spinWheel = (creatorUserId: string, expectedPrice?: number) =>
  API.post<SpinResult>('/v1/payment-service/spin-wheel/spin', {
    creatorUserId,
    expectedPrice,
  }).then((r) => r.data);

// Công khai — người xem và overlay OBS đọc được không cần đăng nhập.
export const getPublicSpinWheel = (userId: string) =>
  API.get<SpinWheel>('/v1/payment-service/public/creator-spin-wheel', {
    params: { userId },
  }).then((r) => r.data);
